

import { Component } from 'vue-property-decorator'
import { TransactionBase } from '../modules/mixin'
import { PageType } from '../modules/type';


// Extending the Super class component
@Component
export default class AllTransaction extends TransactionBase {

    public type:PageType = '';
    public createName: string = ''
}